export default "https://cdn-static.gokick.com/assets/4894ba43e4289cab16e653fbabc6637092de6282/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";